<template>
  <div class="table-busy-skeleton">
    <div
      v-for="r in rows"
      :key="`row-${r}`"
      class="skeleton-row"
    >
      <div
        v-for="(field, idx) in normalizedFields"
        :key="`col-${idx}`"
        :class="['skeleton-col', field.class]"
        :style="getColStyle(field)"
      >
        <b-skeleton :width="getSkeletonWidth(field, r)" class="m-0"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TablesSkeleton",
  props: {
    fields: { type: Array, required: true },
    rows: { type: Number, default: 4 },
  },
  computed: {
    normalizedFields() {
      return this.fields.map(f => (typeof f === "string" ? { key: f } : f));
    },
  },
  methods: {
    getColStyle(field) {
      const key = field.key || "";
      const isSmall = ["selected", "action", "actions", "id"].includes(key.toLowerCase());

      if (isSmall) {
        return { flex: "0 0 50px", width: "50px", justifyContent: "center" };
      }
      return { flex: "1" };
    },
    getSkeletonWidth(field, rowIdx) {
      const key = field.key || "";
      const isSmall = ["selected", "action", "actions"].includes(key.toLowerCase());

      if (isSmall) return "20px";
      if (key.toLowerCase() === 'id') return "30px";

      const widths = ["60%", "85%", "70%", "90%", "75%"];
      const hash = (rowIdx * 3) + key.length;
      return widths[hash % widths.length];
    },
  },
};
</script>

<style scoped>
.table-busy-skeleton {
  margin: -8px;
  width: calc(100% + 16px) !important;
  display: flex;
  flex-direction: column;
}

.skeleton-row {
  display: flex;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid #E9EDF3;
  background-color: #FFFFFF;
}

.skeleton-row:last-child {
  border-bottom: none;
}

.skeleton-col {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 8px;
  border-right: 1px solid #E9EDF3;
  overflow: hidden;
}

.skeleton-col:last-child {
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/TablesSkeleton.vue